import anime from 'animejs/lib/anime.es.js';
import VideoPlayer from './VideoPlayer';

// Animaties returnen een promise
import slideInText from '../animations/slideInText';
import slideOutText from '../animations/slideOutText';
import fadeInText from '../animations/fadeInText';
import fadeOutText from '../animations/fadeOutText';
import fadeInQuote from '../animations/fadeInQuote';
import fadeOutQuote from '../animations/fadeOutQuote';
import slideInLayer from '../animations/slideInLayer';
import slideOutLayer from '../animations/slideOutLayer';
import slideInTextLayer from '../animations/slideInTextLayer';
import slideOutTextLayer from '../animations/slideOutTextLayer';

export default class Slide {
	constructor({ id, slideId, type, subType }) {
		this.id = id;
		this.slideId = slideId;
		this.type = type;
		this.subType = subType;
		this.el = document.querySelector(`[data-id="${this.id}"]`);
		this.parentSlide = null;
		this.prevSlide = null;
		this.nextSlide = null;
		this.video = type == 'video' ? this.el.querySelector('.c-slide__video') : null;
		this.layer = this.el.querySelector('.c-slide-layer');
		this.layerActive = false;
		this.layerAnimating = false;
		this.layerButton = null;
		this.videoPlayer = null;
	}

	init(slides) {
		this.slides = slides;
		this.setNextSlide();
		this.setPrevSlide();
		this.setParentSlide();

		if (this.video) {
			this.videoPlayer = new VideoPlayer(this.el);
			this.videoPlayer.init();
		}

		if (this.layer) {
			this.layerButton = this.el.querySelector('.c-slide__layer-button');
			this.layerButton.addEventListener('click', e => {
				this.toggleLayer();
			});
		}
	}

	setPrevSlide() {
		const index = this.slides.findIndex(slide => slide.id == this.id);

		if (index == 0) {
			this.prevSlide = null;
		} else {
			this.prevSlide = this.slides[index - 1];
		}
	}

	setNextSlide() {
		const index = this.slides.findIndex(slide => slide.id == this.id);

		if (index > this.slides.length) {
			this.nextSlide = null;
		} else {
			this.nextSlide = this.slides[index + 1];
		}
	}

	setParentSlide() {
		this.parentSlide = this.slides.find(slide => slide.slideId == this.slideId);
	}

	reset() {
		this.removeIsActive();

		if (this.type == '3-4' && this.subType == 'inc-text') {
			anime.set(this.el.querySelector('.c-slide-text--3-4-full .c-slide-text__text'), {
				opacity: 1,
			});

			anime.set(this.el.querySelector('.c-slide-text--3-4-full .c-slide-text__bg'), {
				translateX: '0%',
			});
		}

		if (this.type !== 'text') {
			return;
		}

		this.closeLayer();

		if (this.subType == 'quote-transparent') {
			anime.set(this.el, {
				opacity: 0,
			});
		} else {
			anime.set(this.el, {
				opacity: 1,
			});

			anime.set(this.el.querySelector('.c-slide-text__bg'), {
				translateX: '100%',
			});

			anime.set(this.el.querySelector('.c-slide-text__text'), {
				opacity: 0,
			});
		}
	}

	enter(direction) {
		// this.el.classList.add('is-active');
		this.addIsActive();

		// debugger;

		if (this.type == '3-4' && this.subType == 'inc-text' && direction == 'prev') {
			// Er zitten verder geen slides in deze slide dus hoeft er niets geanimeerd te worden
			if (this.prevSlide && this.prevSlide.slideId !== this.slideId) {
				fadeInText(this.el);
				return;
			}

			// Dit werkt omdat de we de eerste tekstslide willen animeren
			// slideInText(this.el);
			fadeInText(this.el);
			return;
		}

		if (this.type !== 'text') {
			return;
		}

		this.parentSlide.closeLayer();

		// Eerste tekstblok in een slide
		if (this.prevSlide && this.prevSlide.type !== 'text' && direction == 'next') {
			if (this.subType == 'quote-transparent') {
				fadeInQuote(this.el);
			} else {
				if (this.prevSlide.type == '3-4' && this.prevSlide.subType == 'inc-text') {
					fadeInText(this.el);
				} else {
					slideInText(this.el);
				}
			}

			return;
		}

		// Animaties tussen tekstblokken
		if ((this.prevSlide && this.prevSlide.type == 'text' && direction == 'next') || direction == 'prev') {
			if (this.subType == 'quote-transparent') {
				fadeInQuote(this.el);
			} else {
				if (this.parentSlide.type == '3-4' && this.parentSlide.subType == 'inc-text') {
					fadeInText(this.el);
				} else {
					slideInText(this.el);
				}
			}

			return;
		}
	}

	// Leave returned een promise zodat de volgende enter animatie daarna kan starten
	leave(direction) {
		// this.el.classList.remove('is-active');
		this.removeIsActive();

		// Sluit sowieso de layer
		this.closeLayer();

		// debugger;

		if (this.type == '3-4' && this.subType == 'inc-text' && direction == 'next') {
			return new Promise(resolve => {
				// Er zitten verder geen slides in deze slide dus hoeft er niets geanimeerd te worden
				if (this.nextSlide && this.nextSlide.slideId !== this.slideId) {
					resolve();
					return;
				}

				// Dit werkt omdat de we de eerste tekstslide willen animeren
				// slideOutText(this.el).then(resolve);
				fadeOutText(this.el).then(resolve);
				return;
			});
		}

		// Bij het verlaten van de slide wordt gechecked:
		// * Gaan we naar andere hoofdslide (slideId)
		// * Is het type van de vorige slide 'text'
		// * Is de parent slide van die slide een 3-4 slide met text
		// Dan moet de text slide die in de parent slide zit, de eerste text slide van een 3-4 slide zit IN die parent slide, worden verborgen
		if (
			this.prevSlide &&
			this.prevSlide.slideId !== this.slideId &&
			this.prevSlide.type == 'text' &&
			this.prevSlide.parentSlide.type == '3-4' &&
			this.prevSlide.parentSlide.subType == 'inc-text'
		) {
			anime.set(this.prevSlide.parentSlide.el.querySelector('.c-slide-text--3-4-full .c-slide-text__text'), {
				opacity: 0,
			});

			anime.set(this.prevSlide.parentSlide.el.querySelector('.c-slide-text--3-4-full .c-slide-text__bg'), {
				translateX: '100%',
			});
		}

		if (this.type !== 'text') {
			return new Promise(resolve => {
				resolve();
				return;
			});
		}

		return new Promise(resolve => {
			// Eerste tekstblok in een slide
			if (this.prevSlide && this.prevSlide.type !== 'text' && direction == 'prev') {
				if (this.subType !== 'quote-transparent') {
					if (this.prevSlide.type == '3-4' && this.prevSlide.subType == 'inc-text') {
						fadeOutText(this.el).then(resolve);
					} else {
						slideOutText(this.el).then(resolve);
					}
				} else {
					fadeOutQuote(this.el).then(resolve);
				}

				return;
			}

			if (this.nextSlide && this.nextSlide.slideId !== this.slideId && direction == 'next') {
				// Laatste slide, laat staan zoals het is maar sluit layer in parent
				this.parentSlide.closeLayer();
				resolve();
				return;
			} else {
				// Standaard leave animatie is fade out
				if (this.subType == 'quote-transparent') {
					fadeOutQuote(this.el).then(resolve);
				} else {
					if (this.parentSlide.type == '3-4' && this.parentSlide.subType == 'inc-text') {
						fadeOutText(this.el).then(resolve);
					} else {
						slideOutText(this.el).then(resolve);
					}
				}
			}
		});
	}

	addIsActive() {
		this.el.classList.add('is-active');
	}

	removeIsActive() {
		this.el.classList.remove('is-active');
	}

	playVideo() {
		if (!this.videoPlayer) {
			return;
		}

		this.videoPlayer.play();
	}

	pauseVideo() {
		if (!this.videoPlayer) {
			return;
		}

		this.videoPlayer.pause();
	}

	toggleLayer(button) {
		this.layerActive ? this.closeLayer() : this.openLayer();
	}

	openLayer() {
		if (!this.layer || this.layerActive || this.layerAnimating) {
			return;
		}

		this.layerActive = true;
		this.layerAnimating = true;
		// this.layer.classList.add('is-active');
		this.layerButton.classList.add('is-active');

		if (this.layer.classList.contains('c-slide-layer--image')) {
			slideInLayer(this.layer).then(() => (this.layerAnimating = false));
		}

		if (this.layer.classList.contains('c-slide-layer--text')) {
			slideInTextLayer(this.layer).then(() => (this.layerAnimating = false));
		}
	}

	closeLayer() {
		if (!this.layer || !this.layerActive || this.layerAnimating) {
			return;
		}

		this.layerActive = false;
		this.layerAnimating = true;
		// this.layer.classList.remove('is-active');
		this.layerButton.classList.remove('is-active');

		if (this.layer.classList.contains('c-slide-layer--image')) {
			slideOutLayer(this.layer).then(() => (this.layerAnimating = false));
		}

		if (this.layer.classList.contains('c-slide-layer--text')) {
			slideOutTextLayer(this.layer).then(() => (this.layerAnimating = false));
		}
	}
}
